import { render, staticRenderFns } from "./checkVRL.vue?vue&type=template&id=64fcaa65&scoped=true&"
import script from "./checkVRL.vue?vue&type=script&lang=js&"
export * from "./checkVRL.vue?vue&type=script&lang=js&"
import style0 from "./checkVRL.vue?vue&type=style&index=0&id=64fcaa65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fcaa65",
  null
  
)

export default component.exports